import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import styles from './Payments.module.css';
import PaymentsHeader from './PaymentsHeader';
import PaymentSetupCard from './PaymentSetupCard';
import InvoicesCard from './InvoicesCard';
import PayoutsCard from './PayoutsCard';

const walkthrough = {
  title: 'How to use the payments features',
  durationLabel: '2 min',
  embedUrl: 'https://player.vimeo.com/video/1170342918?badge=0&autopause=0&player_id=0&app_id=58479'
};

const PaymentsContainer = () => {
  const { jeweller } = useAuth();
  const navigate = useNavigate();
  
  const isStripeConnected = jeweller?.stripe?.status === "connected";

  const handleInvoicesClick = () => {
    if (isStripeConnected) {
      navigate('/invoices');
    } else {
      alert('Please set up payments first to access invoices. Complete your Stripe Connect setup.');
    }
  };

  const handlePayoutsClick = () => {
    if (isStripeConnected) {
      navigate('/payouts');
    } else {
      alert('Please set up payments first to access payouts. Complete your Stripe Connect setup.');
    }
  };

  return (
    <div className={styles.container}>
      <PaymentsHeader
        isStripeConnected={isStripeConnected}
        walkthrough={walkthrough}
      />
      
      {!isStripeConnected && (
        <PaymentSetupCard />
      )}
      
      <div className={styles.cardsGrid}>
        <InvoicesCard 
          isEnabled={isStripeConnected}
          onClick={handleInvoicesClick}
        />
        <PayoutsCard 
          isEnabled={isStripeConnected}
          onClick={handlePayoutsClick}
        />
      </div>
    </div>
  );
};

export default PaymentsContainer;